import React from 'react'
import {PageData} from '../../types'
import {useGTMTracking} from './useGTMTracking'

export const Tracking: React.FC<{page: PageData}> = ({page}) => {
	useGTMTracking(window['__GTM_TRACKING__'], page.url, page.title)

	return null
}
